import useIsTouchDevice from './useIsTouchDevice';

useIsTouchDevice.init();

export * from './useIsTouchDevice';
export default useIsTouchDevice;
